import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import axios from 'axios';
import VueAxios from 'vue-axios'
import Toasted from 'vue-toasted'
import VueCurrencyFilter from 'vue-currency-filter'
import VueCharts from 'vue-chartjs'
import VueTheMask from 'vue-the-mask'
import masker from 'vue-the-mask/src/masker';
import tokens from 'vue-the-mask/src/tokens';
import Spinner from 'vue-spinkit';
import App from './App';
import router from './public/router';
import store from './public/api/store';

Vue.component('Spinner', Spinner)
Vue.filter('mask', (value, mask) => masker(value, mask, true, tokens));
Vue.use(VueTheMask)
Vue.use(VueCharts)
Vue.use(VueCurrencyFilter, {
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})
Vue.use(VueMaterial)
Vue.use(VueAxios, axios)
Vue.use(Toasted)

Vue.config.productionTip = false

const app = new Vue({
  el: '#app',
  store,
  router,
  axios,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js